export const reputationMatchResultList = [ // 지인평판 일치도에 따른 결과
    { key: 60, value: '아직은 어색한 우리사이! 조금 더 자주 보는거 어때요?' }, // 60점 이하
    { key: 61, value: '내가 정말 그렇다고~?! 우리, 대화가 필요해!' }, // 61~70
    { key: 71, value: '아직은 모르는게 많아~ 친구야 우리 놀러갈까?' }, // 71~80
    { key: 81, value: '생각하는대로~ 편하게! 함께 할 때 마음이 잘 통하는 우리 사이!' }, // 81~90
    { key: 91, value: '네 맘이 내 맘이고, 척하면 척이지! 두 분, 절친 맞군요?' }, // 91~95
    { key: 96, value: '혹시 두분.. 영혼의 단짝? 엄청나네요, 우리 우정 영원히!' }] // 96~100